import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { ToWords } from 'to-words';

@Component({
  selector: 'app-issue-seller-credit-note-register-component',
  templateUrl: './issue-seller-credit-note-register-component.component.html',
  styleUrls: ['./issue-seller-credit-note-register-component.component.scss']
})
export class IssueSellerCreditNoteRegisterComponentComponent implements OnInit {
  credit_voc_no: string[] = [];
  creditNoteList: any[] = [];
  toWords: ToWords = new ToWords({ localeCode: 'en-IN' });

  constructor(
    public service: DigisubservicesService,
    private dialogRef: MatDialogRef<IssueSellerCreditNoteRegisterComponentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    const receiptData = this.data?.receiptdata || [];

    if (!Array.isArray(receiptData) || receiptData.length === 0) {
      console.error(' receiptdata is missing or not an array');
      return;
    }

    this.credit_voc_no = receiptData.map(item => item.credit_voc_no);

    this.service.getIssueCrdtwise(this.credit_voc_no).subscribe((res: any[]) => {
      this.creditNoteList = res.map(note => ({
        ...note,
        totalInWords: note.creadit_note_amt
          ? this.toWords.convert(Number(note.creadit_note_amt)) + ' Only'
          : '-'
      }));
    });
  }


}
